export default __webpack_public_path__ + "static/tag-dont-2-dark-967a3a6267dc86b759ed01ecf30eaebd.png";